<template>
  <div class="relative box-progress">
    <div class="progress-text text-skin-tertiary">
      PROGRESO <span class="percent text-skin-tertiary"> {{ Math.round(GET_PROGRESS) }}%</span>
    </div>
    <div class="total-progress">
      <div class="progress" :style="`width: ${Math.round(GET_PROGRESS)}%!important`"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      percent: 60,
    };
  },
  mounted(){
    this.getProgress()
  },
  computed: {
    ...mapGetters("progress", ["GET_PROGRESS"]),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  methods:{
      getProgress() {
              
      let body = {
        _mounted_course_id: this.$route.params.id,
      }
      this.$store.dispatch("progress/get_progress", {
        _body: body,
      });
    },

  }

};
</script>

<style scoped>
.progress {
  height: 6px;
  background: #e55974;
  border-radius: 10px;
  position: relative;
  z-index: 2;
}

.box-progress {
  width: 200px;
  padding-top: 10px;
}

.total-progress {
  background: #cccccc 0% 0% no-repeat padding-box;
  width: 150px;
  border-radius: 10px;
  position: relative;
}

.progress-text {
  font: normal normal bold 13px/22px Roboto;
}

.percent {
  font: normal normal bold 19px/23px Roboto;
  letter-spacing: 0px;
  padding-left: 50px;
}
</style>
